/**
 * Show selected amount
 */
$(document).on('change', '.form-group-amount input', function() {
    var amount = $(this).val();
    if(amount) {
        amount = amount.replace('€', '');
        $('.selected-gift span').text('€'+amount);
    }
});

/**
 * Empty hidden fields
 */
$(document).on('click', 'button.cf7mls_next', function() {
    // Leeg alle verborgen invoervelden
    $('.check_conditional_fields .wpcf7cf-hidden input[type="text"]').val('');
    $('.check_conditional_fields .wpcf7cf-hidden input[type="number"]').val('');

    // Deselecteer alle verborgen checkboxes
    $('.check_conditional_fields .wpcf7cf-hidden input[type="checkbox"]').prop('checked', false);
    
    // Deselecteer alle verborgen radio buttons
    $('.check_conditional_fields .wpcf7cf-hidden input[type="radio"]').prop('checked', false);
});

// add class to form
$('.module--geven__content__form form.wpcf7-form').addClass('module--geven__content__form--form');

// if form is submitted and has class module--geven__content__form--form then show custom success message
document.addEventListener( 'wpcf7mailsent', function( event ) {
    if(event.target.classList.contains('module--geven__content__form--form')){
        $('.module--geven__content__form form').remove();
        $('.module--geven__form__content').remove();
        $('.module--geven__content__form__success').show();
    }
}, false );

$(".geven-form br").remove();
$(".cf7mls-btns").addClass('non-active');
$(".cf7mls_next").attr('disabled', true);

if($('input[value="Maandelijks"]').is(":checked")){
    $(".cf7mls-btns").removeClass('non-active');
    $(".cf7mls_next").attr('disabled', false);
}

$(document).on('click', 'input[name="period_geven"]', function() {
    if($('input[value="Maandelijks"]').is(":checked")){
        $(".cf7mls-btns").removeClass('non-active');
        $(".cf7mls_next").attr('disabled', false);
    }else{
        $(".cf7mls-btns").addClass('non-active');
        $(".cf7mls_next").attr('disabled', true);
    }
});

/**
 * Validate email
 */
function validateEmail($email) {
    var emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test( $email );
}

/**
 * Click event
 */
$('#geven-button-eenmalig, #geven-button-maandelijks').on('click', function(event) {
    const subject = $(this).data('subject');
    giveMoneyUsingMollie($(this), event, subject);
});

/**
 * Uncheck selected amounts when other amount is entered
 *
 */
$('input[name="otheramount"]').on('keypress change', function() {
    const form = $(this).parents('.geven-form');
    form.find('input[name="amount"]').prop('checked', false);
});

/**
 * Clear other amount field when a fixed amount is selected
 */
$('input[name="amount"]').on('click', function() {
    const form = $(this).parents('form');
    form.find('input[name="otheramount"]').val('');
});

/**
 * Function that calls AJAX request to pay desired once or monthly using mollie payments.
 * TODO Form validation inbouwen
 *
 * @param {obj} element
 * @param {obj} event
 * @param {string} subject
 */
function giveMoneyUsingMollie( element, event, subject ) {
    event.preventDefault();
    $('.geven-form__validations').hide().html('');
    $('input').removeClass('geven-form__error');
    const form = element.parents('.geven-form');
    const amountRadio = form.find('input[name="amount"]:checked').val();
    const amountOther = form.find('input[name="otheramount"]').val();
    const fname = form.find('input[name="firstname"]').val();
    const lname = form.find('input[name="lastname"]').val();
    const name = fname + ' ' + lname;
    const email = form.find('input[name="email"]').val();

    let amount;
    if( amountOther ) {
        amount = amountOther
    } else {
        amount = amountRadio
    }

    let action;
    if(element.attr('id') === 'geven-button-maandelijks') {
        action = 'doorbrekers_maandelijks_geven';
        // validate amount
        if(!amount || amount <= 0){
            $('.geven-form__validations').show().append('<p class="geven-form__validations__error">Kies een bedrag</p>');
        }
        // validate firstname
        if(!fname){
            form.find('input[name="firstname"]').addClass('geven-form__error');
            $('.geven-form__validations').show().append('<p class="geven-form__validations__error">Voornaam is verplicht</p>');
        }
        // validate lastname
        if(!lname){
            form.find('input[name="lastname"]').addClass('geven-form__error');
            $('.geven-form__validations').show().append('<p class="geven-form__validations__error">Achternaam is verplicht</p>');
        }
        // validate email
        if(!email){
            form.find('input[name="email"]').addClass('geven-form__error');
            $('.geven-form__validations').show().append('<p class="geven-form__validations__error">E-mail is verplicht</p>');
        }else if(!validateEmail(email)) {
            form.find('input[name="email"]').addClass('geven-form__error');
            $('.geven-form__validations').show().append('<p class="geven-form__validations__error">E-mail is ongeldig</p>');
        }
    } else {
        action = 'doorbrekers_eenmalig_geven';

        // validate only amount
        if(!amount || amount <= 0){
            $('.geven-form__validations').show().append('<p class="geven-form__validations__error">Kies een bedrag</p>');
        }
    }

    // check if there are no errors and if amount exists and is higher then zero
    if(form.find('.geven-form__error').length === 0 && amount && amount > 0){
        $.ajax({
            url: window.ajaxvars.ajax_url,
            type: 'post',
            data: {
                action: action,
                amount: amount,
                email: email,
                name: name,
                subject: subject,
            },
            beforeSend: function() {
                // if( action === 'doorbrekers_maandelijks_geven') {
                //     element.after('<div class="archive__container__loader"></div>');
                // }
                if(form.find('.archive__container__loader').length === 0){
                    form.append('<div class="archive__container__loader"></div>');
                }
            },
            success: function(response) {
                let data = null;
                try {
                    data = JSON.parse(response);
                } catch (e) {
                    data = null;
                }

                if (data && data.redirect) {
                    window.location = data.redirect;
                    return;
                }

                // Geen redirect terug: loader weghalen en melding tonen
                // in plaats van eindeloos blijven laden.
                $('.archive__container__loader').remove();
                $('.geven-form__validations').show().append('<p class="geven-form__validations__error">Er is iets fout gegaan, probeer het opnieuw of neem contact op met DoorBrekers.</p>');
                console.error('Geven: onverwachte response', response);
            },
            error: function (error) {
                $('.archive__container__loader').remove();
                $('.geven-form__validations').show().append('<p class="geven-form__validations__error">Er is iets fout gegaan, probeer het opnieuw of neem contact op met DoorBrekers.</p>');
                console.error(error);
                console.log(error.responseText);
            },
        });
    }
}
